<template>
  <span ref="toggletip" class="toggletip">
    <component
      :is="buttonComponent"
      :aria-label="activatorLabel"
      @click="toggle"
      @blur="close"
      @keydown.esc="close"
    />
    <span role="status" aria-atomic="true">
      <span
        v-if="show"
        ref="toggletipMessage"
        class="toggletip__message pa-1 pa-md-0"
        :style="toggletipPosition"
      >
        <div class="dimer inverted--text py-2 px-3 rounded-4">
          <slot />
        </div>
      </span>
    </span>
  </span>
</template>

<script>
import DefaultToggletipButton from "~/components/page/components/toggletip/buttons/DefaultToggletipButton.vue";
import ResearchDirectionsQuestionToggletipButton from "~/components/page/components/toggletip/buttons/ResearchDirectionsQuestionToggletipButton.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Toggletip",
  components: {
    DefaultToggletipButton,
    ResearchDirectionsQuestionToggletipButton,
  },
  props: {
    width: { type: Number, required: true },
    activatorLabel: { type: String, default: "show help information" },
    buttonComponent: { type: String, default: "DefaultToggletipButton" },
  },
  data() {
    return {
      show: false,
      maxWidth: undefined,
      toggletipLeft: 0,
    };
  },
  computed: {
    toggletipPosition() {
      return {
        left: `${this.toggletipLeft}px`,
        width: `${this.width}px`,
        maxWidth: `${this.maxWidth}px`,
      };
    },
  },
  methods: {
    toggle() {
      this.show = !this.show;
      if (!this.show) return;

      this.$nextTick(() => {
        const { clientWidth } = document.body;
        const { width: toggletipMessageWidth } =
          this.$refs.toggletipMessage.getBoundingClientRect();
        const { left: toggletipLeft } =
          this.$refs.toggletip.getBoundingClientRect();

        this.maxWidth =
          toggletipMessageWidth >= clientWidth ? clientWidth : this.width;

        // if toggle text still goes over right of screen, shift to the left
        if (toggletipLeft + this.maxWidth > clientWidth) {
          this.toggletipLeft = clientWidth - (toggletipLeft + this.maxWidth);
        }
      });
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.toggletip {
  position: relative;
  bottom: 4px;

  &__message {
    position: absolute;
    bottom: 42px;
    opacity: 0.9;
    line-height: 1.5;
    font-size: 90%;
    z-index: 10;
  }
}
</style>
